'use strict';

const print = function (condition, message) {
  let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'error';
  if (condition) {
    return;
  }
  if (typeof console !== 'undefined') {
    let logFunction = console[type];
    if (typeof logFunction !== 'function') logFunction = console.error;
    logFunction(message);
  }
  try {
    throw new Error(message);
  } catch (x) {}
};
const warning = process.env.NODE_ENV !== "'production'" && process.env.NODE_ENV !== "production" ? print : () => {};
module.exports = warning;
